export default "__VITE_ASSET__DMxvGZFd__"